import { inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { DevicesActions } from './devices.actions';

/**
 * @deprecated
 */
export const deviceResolver: ResolveFn<void> = () => {
  return inject(Store).dispatch(DevicesActions.loadAllClientDevices());
};

export const deviceDetailsResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot) => {
  const locationId = route.paramMap.get('locationId') || '';
  const deviceId = route.paramMap.get('deviceId') || '';

  return inject(Store).dispatch(DevicesActions.loadDeviceDetails({ deviceId, locationId }));
};

export const addDeviceFormResolver: ResolveFn<void> = () => {
  inject(Store).dispatch(DevicesActions.loadDeviceCollections());
};
